import { FC } from 'react';

import { useRecoilValue } from 'recoil';

import {
  flowerPriceTableDataAtom,
  flowerPriceTableStatusAtom,
} from '@shared/api/priceTable/flowerPriceTable.atom';
import { useFlowerPriceTableHook } from '@shared/api/priceTable/flowerPriceTable.hook';
import { Loading } from '@shared/components/Loading';
import PriceTableView from '@shared/components/PriceTableView';
import StatPageSideBar from '@shared/components/StatPageSideBar';
import { useParams } from 'react-router-dom';

import { useTitleHook } from '../hooks/useTitleHook';

/**
 * 화환내역(정산 상세)과 동일한 원가 보정.
 * priceWhole 끝자리가 7500이면 포장비 2500을 더해 만원 단위로 맞춘다. (예: 17,500 → 20,000)
 * 모듈 레벨 상수로 두어 PriceTableView useMemo 참조 안정성을 보장한다.
 */
const adjustFlowerPriceWhole = (priceWhole: number) =>
  priceWhole % 10000 === 7500 ? priceWhole + 2500 : priceWhole;

/**
 * 화환 단가표 페이지.
 * 현재 판매중인 화환(shopItem)의 판매가·원가·프리드(상조) 수익금·원가율을 보여준다.
 */
const AgencyAdminFlowerPriceTablePage: FC = function AgencyAdminFlowerPriceTablePage() {
  useTitleHook('관리자용 페이지', undefined, undefined, true, '/');
  const { bugoBrandId } = useParams();

  useFlowerPriceTableHook(bugoBrandId);

  const status = useRecoilValue(flowerPriceTableStatusAtom);
  const data = useRecoilValue(flowerPriceTableDataAtom);

  return (
    <div className="flex">
      <div className="flex flex-col">
        <StatPageSideBar />
      </div>
      <div className="mx-auto max-w-screen-2xl flex-1 px-10 py-8">
        <p className="text-20 font-bold">화환 단가표</p>
        <p className="font-sm pt-2 pb-6 text-gray-500">
          현재 판매중인 화환 상품의 판매가, 원가, 프리드 수익금입니다.
        </p>
        {data ? (
          <div className="relative">
            {status !== 'success' && (
              <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/60">
                <Loading />
              </div>
            )}
            <PriceTableView
              items={data.data}
              adjustWhole={adjustFlowerPriceWhole}
              showCostRate={false}
              tableName="화환 단가표"
            />
          </div>
        ) : (
          <div className="center-box h-screen-15">
            <Loading />
          </div>
        )}
      </div>
    </div>
  );
};

export default AgencyAdminFlowerPriceTablePage;
